
import {Component, Prop, Vue} from "vue-property-decorator";
import {range} from "@/auxillary/range";
import {stringify} from "@/auxillary/datafield.stringify";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'ScaleReadonly',
  components: {
  },
})
export default class ScaleReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  errorMessage: string = "";

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName;
  }

  get values() {
    return [...range(this.min, this.max, this.step)];
  }

  get min() {
    return this.field.definition.min ?? 0;
  }

  get step() {
    return this.field.definition.step ?? 1;
  }

  get max() {
    return this.field.definition.max ?? 0;
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get value() {
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : value
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  get field() {
    return this.dataField;
  }

  get minValue() {
    return this.field.definition.min;
  }

  get maxValue() {
    return this.field.definition.max;
  }

}
